<template>
	<div>
		<div class="form__row form__row--without-label">
			<input
				class="checkbox-toggler"
				type="checkbox"
				:checked="multipleDocument"
				@change="multipleDocumentToggle"
				id="multiple-doc"
			/>
			<label for="multiple-doc">Несколько документов</label>
		</div>

		<div v-if="!multipleDocument" class="form__row">
			<label for="doc_types">Тип документа</label>
			<select id="doc_types" name="doc_types">
				<option v-for="item in list" :value="item.id" :key="item.id">{{item.name}}</option>
			</select>
		</div>

		<div v-else class="form__row form__row--without-label task-documents">
			<div v-for="(item,index) in data" :key="index" class="task-documents__item">
				<document-items :group="index" :data="item"></document-items>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  components: {
    "document-items": require("./documentItems.vue").default
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      list: null,
      multipleDocument: false
    };
  },
  methods: {
    concatDoc: function(data) {
      var docListConcat = [];
      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].list.length; j++) {
          docListConcat.push(data[i].list[j]);
        }
      }
      return docListConcat;
    },
    multipleDocumentToggle: function() {
      this.multipleDocument = !this.multipleDocument;
    }
  },
  mounted() {
    this.list = this.concatDoc(this.data);
  }
};
</script>

<style scoped>
.task-documents {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
}

.task-documents__item {
  width: 100%;
  padding: 0 10px 20px 10px;
}

@media (min-width: 768px) {
  .task-documents__item {
    width: 50%;
  }
}
</style>
